module.exports = __webpack_public_path__ + "static/media/Copii care cooperează.fb225484.png";